import { useRouter } from "next/router";
import type { FunctionComponent } from "react";

import { useRouterReplaceWithSanitizedKeys } from "shared/lib/router";

import { SanitizedUrlKeys } from "./consts";
import { DynamicOnboardingModal } from "./dynamics";
import { useOnboarding } from "./hooks";

export const Onboarding: FunctionComponent = () => {
  const {
    entityIdMap,
    isShowOnboardingModal,
    onboardingSlides,
    setIsShowOnboardingModal,
    userType,
  } = useOnboarding();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { pathname, query } = useRouter();

  return isShowOnboardingModal && userType && entityIdMap ? (
    <DynamicOnboardingModal
      entityIdMap={entityIdMap}
      onboardingSlides={onboardingSlides}
      onLastSlide={() => {
        setIsShowOnboardingModal(false);
        // Move the replace to here is because we still need the query string to toggle the visibility of this component
        void replace(
          SanitizedUrlKeys,
          { pathname, query },
          {
            shallow: true,
          },
        );
      }}
      userType={userType}
    />
  ) : null;
};

Onboarding.displayName = "Onboarding";
